// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__27uxA","productName":"Table_productName__23UHb"};